<template>
  <div class="header-admin" :style="{
    'justify-content':!isMobile ? 'space-between':'center'
  }">
    <img :src="headerLogo" class="header-logo" alt="" srcset="" v-if="!isMobile" @click="setClearFn" />
    <img :src="headerLogoMobile" class="header-logo-mobile" alt="" srcset="" @click="setClearFn" v-else />
    <div class="nav-fol-div" @click="onChange" v-if="!isMobile && !isDrawer">
      <img :src="navFold" alt="" class="nav-fold" />
    </div>
    <div id="navFoliv" class="nav-fol-div" @click="drawerChange" v-if="isDrawer">
      <img :src="navFold" alt="" class="nav-fold" />
    </div>

  </div>
</template>

<script>
import headerLogo from '@/assets/header-logo.png'
import headerLogoLaw from '@/assets/header-logo-law.png'
import navFold from '@/assets/nav-fold.png'
import headerLogoMobile from '@/assets/header-logo-mobile.png'
import { mapMutations,mapState } from 'vuex'
export default {
  props:{
    isDrawer:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    '$route':{
      handler(to,from) {
        this.fullPath = from.fullPath
        sessionStorage.setItem('weidun_fullPath',from.fullPath)
      }
    }
  },
  data() {
    return {
      navFold,
      headerLogoMobile,
      fullPath:sessionStorage.getItem('weidun_fullPath') || ''
    }
  },
  computed:{
    ...mapState('mobile',['isMobile']),
    isShowLeftTool(){
      // 如果当前路由是 ai  tankList  tank history
      let aiRouter = ['ai','tankList','tank','history']
      if(aiRouter.indexOf(this.$route.name) != -1){
        return true
      }
      if(this.fullPath.indexOf('knowledge') != -1){
        return false
      }
      if(this.$route.path.indexOf('knowledge') == -1){
        return true
      }
      if(this.$route.path.indexOf('knowledge') != -1){
        return false
      }
    },
    headerLogo(){
      if(!this.isShowLeftTool){
        return headerLogoLaw
      }else{
        return headerLogo
      }
    }
  },
  created(){
    if(this.isDrawer){
      this.setMobile(false)
    }
  },
  methods:{
    ...mapMutations('mobile',['setMobile']),
    ...mapMutations('message',['setClear']),
    ...mapMutations('agent',['setCurrentAgent','clearCurrentAgent']),
    setClearFn(){
      if(!this.isShowLeftTool){
        this.$router.replace('/knowledge')
        return
      }
      if(this.isShowLeftTool){
        this.$router.replace('/ai')
      }
      this.clearCurrentAgent()
      setTimeout(() => {
        this.setClear()
      }, 500)
      this.$emit('drawerChange')
    },
    onChange(){
      this.setMobile(true)
    },
    drawerChange(){
      this.$emit('drawerChange')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-admin{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-logo-mobile{
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.header-logo{
  width: 127px;
  height: 32px;
  cursor: pointer;
}
.nav-fold{
  width: 20px;
  height: 20px;
}
.nav-fol-div{
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-fol-div:hover{
  background: rgba(1,10,28,0.05);
  border-radius: 4px;
}
</style>